// Blog ve rehber içerik yardımcıları (bileşen dosyaları yalnızca bileşen export etsin diye burada).

// Rehber ekran görüntüsü: public/img/rehber/{image}-{960|1800}.webp
export const guideSrc = (image, width) => `/img/rehber/${image}-${width}.webp`;

// Başlıktan Türkçe karakterleri sadeleştirilmiş çapa id'si: "Ne işe yarar?" → "ne-ise-yarar"
const TR_MAP = { ç: 'c', ğ: 'g', ı: 'i', ö: 'o', ş: 's', ü: 'u' };
export const headingId = (text) =>
  text
    .toLocaleLowerCase('tr')
    .replace(/[çğıöşü]/g, (c) => TR_MAP[c])
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
